import * as React from "react";
const AddressSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={69}
    height={68}
    fill="none"
    {...props}
  >
    <rect
      width={60}
      height={60}
      x={4.5}
      y={4}
      fill="#fff"
      fillOpacity={0.03}
      rx={30}
    />
    <rect
      width={60}
      height={60}
      x={4.5}
      y={4}
      stroke="#fff"
      strokeOpacity={0.06}
      strokeWidth={8}
      rx={30}
    />
    <path
      stroke="#EF4136"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M35 34.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
    />
    <path
      stroke="#EF4136"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M35 44c2-4 8-6.582 8-12a8 8 0 1 0-16 0c0 5.418 6 8 8 12Z"
    />
  </svg>
);
export default AddressSVG;
